export default __webpack_public_path__ + "static/media/icon.5552f770.png";